import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top on every route change so newly-mounted pages
// don't appear "empty" when navigated to from a scrolled footer.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
